import { StringColumn, CategoricalColumn, NumericalColumn, BooleanColumn } from 'baseui/data-table';
import _get from 'lodash/get';
import { EMPTY_STRING, EMPTY_NUMBER } from 'commons-ui';
import dayjs from 'dayjs';

export const COL_NAMES = {
	zupeeUserId: 'zupeeUserId',
	gameName: 'gameName',
	tournamentId: 'tournamentId',
	transactionId: 'transactionId',
	refundReason: 'refundReason',
	freshdeskTicketId: 'freshdeskTicketId',
	jiraTicketId: 'jiraTicketId',
	requesterEmailId: 'requesterEmailId',
	refundSuggestionResult: 'refundSuggestionResult',
	refundSuggestionReason: 'refundSuggestionReason',
	leniencyResult: 'leniencyResult',
	isLeniencyRefund: 'isLenientRefund',
	leniencyRefundReason: 'reason',
	tournamentStartTime: 'tournamentStartTime',
	entryFee: 'entryFee',
	approvalStatus: 'approvalStatus',
	refundStatus: 'refundStatus',
	requestCreatedAt: 'requestCreatedAt',
	requestUpdatedAt: 'requestUpdatedAt',
	supervisedBy: 'supervisedBy'
};

export const columnConfigs = [
	NumericalColumn({
		title: 'Zupee UID',
		mapDataToValue: (data: any) => data[COL_NAMES.zupeeUserId] || EMPTY_NUMBER
	}),
	CategoricalColumn({
		title: 'Game name',
		mapDataToValue: (data: any) => data[COL_NAMES.gameName] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Tournament ID',
		mapDataToValue: (data: any) => (data[COL_NAMES.tournamentId] || EMPTY_STRING).toString()
	}),
	StringColumn({
		title: 'Tournament date',
		minWidth: 200,
		maxWidth: 300,
		mapDataToValue: (data: any) => {
			return (
				_get(data, COL_NAMES.tournamentStartTime)
					? dayjs(new Date(_get(data, COL_NAMES.tournamentStartTime))).format('DD-MM-YYYY hh:mm A')
					: 'NA'
			).toString();
		}
	}),
	StringColumn({
		title: 'Transaction Id',
		mapDataToValue: (data: any) => (data[COL_NAMES.transactionId] || EMPTY_STRING).toString()
	}),
	NumericalColumn({
		title: 'Entry fee',
		mapDataToValue: (data: any) => data[COL_NAMES.entryFee] || EMPTY_NUMBER
	}),
	CategoricalColumn({
		title: 'Refund suggestion result',
		mapDataToValue: (data: any) => (data[COL_NAMES.refundSuggestionResult] || EMPTY_STRING).toString()
	}),
	StringColumn({
		title: 'Request createdBy',
		mapDataToValue: (data: any) => (data[COL_NAMES.requesterEmailId] || EMPTY_STRING).toString()
	}),
	StringColumn({
		title: 'Request createdAt',
		minWidth: 200,
		maxWidth: 300,
		mapDataToValue: (data: any) => {
			return (
				_get(data, COL_NAMES.requestCreatedAt)
					? dayjs(new Date(_get(data, COL_NAMES.requestCreatedAt))).format('DD-MM-YYYY hh:mm A')
					: 'NA'
			).toString();
		}
	}),
	StringColumn({
		title: 'Request updatedAt',
		minWidth: 200,
		maxWidth: 300,
		mapDataToValue: (data: any) => {
			return (
				_get(data, COL_NAMES.requestUpdatedAt)
					? dayjs(new Date(_get(data, COL_NAMES.requestUpdatedAt))).format('DD-MM-YYYY hh:mm A')
					: 'NA'
			).toString();
		}
	}),
	StringColumn({
		title: 'FD ticket',
		minWidth: 200,
		maxWidth: 300,
		mapDataToValue: (data: any) => (data[COL_NAMES.freshdeskTicketId] || EMPTY_STRING).toString()
	}),
	StringColumn({
		title: 'Jira ticket',
		minWidth: 200,
		maxWidth: 300,
		mapDataToValue: (data: any) => (data[COL_NAMES.jiraTicketId] || EMPTY_STRING).toString()
	}),
	CategoricalColumn({
		title: 'Refund Suggestion reason',
		minWidth: 300,
		maxWidth: 400,
		mapDataToValue: (data: any) => (data[COL_NAMES.refundSuggestionReason] || EMPTY_STRING).toString()
	}),
	CategoricalColumn({
		title: 'Refund reason',
		minWidth: 300,
		maxWidth: 400,
		mapDataToValue: (data: any) => (data[COL_NAMES.refundReason] || EMPTY_STRING).toString()
	}),
	BooleanColumn({
		title: 'Leniency Refund',
		minWidth: 300,
		maxWidth: 400,
		mapDataToValue: (data: any) => _get(data[COL_NAMES.leniencyResult], [COL_NAMES.isLeniencyRefund], false)
	}),
	CategoricalColumn({
		title: 'Leniency Refund reason',
		minWidth: 300,
		maxWidth: 400,
		mapDataToValue: (data: any) => _get(data[COL_NAMES.leniencyResult], [COL_NAMES.leniencyRefundReason], EMPTY_STRING).toString()
	}),
	StringColumn({
		title: 'Approval status',
		mapDataToValue: (data: any) => (data[COL_NAMES.approvalStatus] || EMPTY_STRING).toString()
	}),
	StringColumn({
		title: 'Refund status',
		mapDataToValue: (data: any) => (data[COL_NAMES.refundStatus] || EMPTY_STRING).toString()
	}),
	StringColumn({
		title: 'Approved/Rejected by',
		minWidth: 200,
		maxWidth: 300,
		mapDataToValue: (data: any) => (data[COL_NAMES.supervisedBy] || EMPTY_STRING).toString()
	})
];
